import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import { CustomDate } from '../../CustomControls/CustomDateTime';

export const MultipleDatesSelector = ({ baseDate, additionalDates, onChange, maxDates, t }) => {

    const handleAddDate = () => {
        if (additionalDates.length >= maxDates) return;

        const lastDate = additionalDates.length > 0
            ? new Date(additionalDates[additionalDates.length - 1])
            : new Date(baseDate);

        const newDate = new Date(lastDate);
        newDate.setDate(newDate.getDate() + 30);

        onChange([...additionalDates, newDate]);
    };

    const handleRemoveDate = (index) => {
        const newDates = additionalDates.filter((_, i) => i !== index);
        onChange(newDates);
    };

    const handleDateChange = (index, value) => {
        const newDates = [...additionalDates];
        newDates[index] = value;
        onChange(newDates);
    };

    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        return d.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    const totalPrescriptions = 1 + additionalDates.length;

    return (
        <div>
            <Row>
                <Col md={12}>
                    <div style={{ marginBottom: '10px' }}>
                        <strong>{t('medicalRecords.prescriptions.baseDate')}:</strong> {formatDate(baseDate)}
                    </div>
                </Col>
            </Row>

            {additionalDates.map((date, index) => (
                <Row key={index} style={{ marginBottom: '10px', alignItems: 'center' }}>
                    <Col md={3}>
                        <CustomDate
                            value={date}
                            name={`additionalDate_${index}`}
                            onChange={(name, value) => handleDateChange(index, value)}
                            closeOnSelect={true}
                            dateFormat="DD/MM/YYYY"
                            inputProps={{ placeholder: "DD/MM/YYYY" }}
                        />
                    </Col>
                    <Col md={2}>
                        <Button bsStyle="danger" bsSize="small" onClick={() => handleRemoveDate(index)}>
                            <i className="fa fa-trash"></i>
                        </Button>
                    </Col>
                </Row>
            ))}

            <Row style={{ marginTop: '10px' }}>
                <Col md={12}>
                    <Button bsStyle="default" onClick={handleAddDate} disabled={additionalDates.length >= maxDates}>
                        <i className="fa fa-calendar-o"></i> {t('medicalRecords.prescriptions.addDate')}
                    </Button>

                    <span style={{ marginLeft: '15px', color: '#666' }}>
                        {t('medicalRecords.prescriptions.totalPrescriptions', { count: totalPrescriptions })}
                        {additionalDates.length >= maxDates && (
                            <span style={{ color: '#d9534f', marginLeft: '10px' }}>
                                ({t('medicalRecords.prescriptions.maxDatesReached')})
                            </span>
                        )}
                    </span>
                </Col>
            </Row>
        </div>
    );
};

MultipleDatesSelector.propTypes = {
    baseDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    additionalDates: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    maxDates: PropTypes.number,
    t: PropTypes.func.isRequired
};

MultipleDatesSelector.defaultProps = {
    additionalDates: [],
    maxDates: 11
};
